export default __webpack_public_path__ + "e5016913eadff8ee7bc7b749611d67ed.jpg";